import { FormattedMessage } from 'react-intl'
import type { Invoice } from './types'
import { useDispatch } from 'react-redux'
import { push } from 'connected-react-router'
import styled from 'styled-components'

type Props = {
	invoice: Invoice
}
const Container = styled.div`
	width: 100%;
	margin: 0.5rem 0 0.5rem 0;
`
const Link = styled.a`
	white-space: nowrap;
	user-select: none;
	margin-bottom: 0;
`

const InvoiceHistoryButton = ({ invoice }: Props) => {
	const dispatch = useDispatch()
	if (!invoice.oldInvoiceUUID) {
		return null
	}

	return (
		<Container>
			<Link
				href="#!"
				onClick={() =>
					dispatch(push(`invoices?uuid=${invoice.oldInvoiceUUID}`))
				}
			>
				<FormattedMessage
					defaultMessage="Linkki laskun vanhaan versioon"
					description="Button label for viewing an invoice history version"
				/>
			</Link>
		</Container>
	)
}

export default InvoiceHistoryButton
